export default __webpack_public_path__ + "static/matheus-c4a8ae952d331f504e0ff1414e503f46.jpg";